module.exports = __webpack_public_path__ + "media/images/emblems/GW-GR-Churwalden_neu-2b967056b42d735f4bff07960ca8a02a.png";